const vm = {
    "vm.title.block1": "線上",
    "vm.title.block2": "試戴",
    "vm.defineClassic": "經典/璀璨系列",
    "vm.defineFresh": "花眸/甜漾系列",
    "vm.learnmore": "了解更多",
    "vm.shownow": "門市查詢",
}

export default vm;